import ActionTypes from '../actions/actionTypes';
/*
Yet to be implemented, code will likely be moved to relevant file upon implementation, accountsReducer.js?
*/
const initialState = {
  isLoading: false,
  currentBillingMethod: 'EFT',
  bankDetails: { },
  creditDetails: { exists: false },
  isError: false
};

function billingReducer(state = initialState, { type, response }) {
  let method = 'EFT';
  let bank = { };
  let credit = { exists:false };
  switch (type) {
    case ActionTypes.BILLING.REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case ActionTypes.BILLING.SUCCESS:
      
      //it seems the codes have some 3 digit number followed by a semicolon then the payment type
      for (let i in response) {
        let record = response[i];
        let paymentType = record.paymentType.match(/\d+;(.+)$/)[1];
        switch (paymentType) {
          case 'Bank Account':
            if (record.code === 'payment account') {
              method = 'Direct Debit - Bank Account';
            }
            bank = {
              name:record.name,
              bsb:record.bic,
              accountNo:record.iban
            };
            break;
          case 'Credit Card':
            if (record.code === 'payment account') {
              method = 'Direct Debit - Credit Card';
            }
            //at the moment we are not displaying credit card details, only need to know if they are in the system
            credit.exists = true;
            break;
        }
      }
      return {
        ...state,
        isLoading: false,
        currentBillingMethod: method,
        bankDetails: bank,
        creditDetails: credit,
      };
    case ActionTypes.BILLING.FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
      }; 
    case ActionTypes.BILLING.RESET:
      return {
        ...state,
        isLoading: false,
        isError: false,
        currentBillingMethod: method,
        bankDetails: bank,
        creditDetails: credit,
      }; 
    default:
      return state;
  }
}

export default billingReducer;
